<template>
  <div>
    <metainfo>
      <template v-slot:title="{ content }">{{ content }}</template>
    </metainfo>
    <Navigation/>
    <notifications class="notifyMsg" group="foo"/>
    <vue3-confirm-dialog></vue3-confirm-dialog>

    <!-- PWA Install Prompt -->
    <div v-if="showInstallPrompt" class="install-prompt">
      <button class="close-btn" @click="dismissPrompt">&times;</button>
      <p><span style="color: red;">⚡</span> Install the Bill Generator app on your device for faster access</p>
      <button @click="installApp" class="install-btn">Install Now</button>
    </div>
  </div>
</template>


<style>
@import "assets/css/icofont/icofont.min.css";
@import "assets/css/boxicons/css/boxicons.min.css";
@import "assets/css/style.css";
@import "assets/css/animation.css";

.notifyMsg {
  z-index: 10000 !important;
}

.install-prompt {
  position: fixed;
  bottom: 20px;
  left: 20px;
  width: 320px;
  background: linear-gradient(135deg, rgba(156, 205, 232, 0.68), #ffffff);
  border-radius: 12px;
  border: 1px solid rgba(0, 128, 128, 0.5);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  padding: 20px;
  text-align: center;
  z-index: 20000;
  animation: fadeIn 0.3s ease, shake 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
  transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
}

.install-prompt p {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

.install-prompt .install-btn {
  display: inline-block;
  padding: 12px 24px;
  background: linear-gradient(90deg, #FF7F50, #FF4500);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  border-radius: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.install-prompt .install-btn:hover {
  background: linear-gradient(90deg, #FF6347, #FF4500);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

.install-prompt .close-btn {
  position: absolute;
  top: 0px;
  right: 5px;
  background: none;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  color: var(--btn-text-color);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.install-prompt .close-btn:hover {
  transform: scale(1.2);
}
</style>

<script>
import Navigation from "./components/Navigation";
import {MX_TRACK} from "@/util/Mixpanel";

export default {
  components: {
    Navigation,
  },
  data() {
    return {
      showInstallPrompt: false,
      deferredPrompt: null,
    };
  },
  mounted() {
    // Listen for the beforeinstallprompt event
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault(); // Prevent the default prompt
      this.deferredPrompt = e; // Save the event
      this.showInstallPrompt = true; // Show custom install UI
    });

    // Handle the appinstalled event
    window.addEventListener("appinstalled", () => {
      console.log("App has been installed");
      MX_TRACK('pwa_app_installed')
      this.showInstallPrompt = false; // Hide the install UI
    });
  },
  methods: {
    installApp() {
      MX_TRACK('pwa_install_clicked')
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt(); // Show the native install prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the install prompt");
          } else {
            console.log("User dismissed the install prompt");
          }
          this.deferredPrompt = null; // Clear the saved prompt
          this.showInstallPrompt = false; // Hide the install UI
        });
      }
    },
    dismissPrompt() {
      MX_TRACK('pwa_install_closed')
      this.showInstallPrompt = false;
    },
  },
};
</script>
